import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

const deleteKategori = async (id: number | string) => {
    const response = await axios.delete(`/api/kategori/${id}`);
    return response.data;
};

export default function useDeleteKategori() {
    const queryClient = useQueryClient();

    return useMutation((id: number | string) => deleteKategori(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(["kategori", "list"]);
        },
    });
}
